<template>
  <div id="imageContainer" ref="imageContainer" v-loading="loadingActive" element-loading-text="拼命加载中">
    <img ref="viewerDom" src="" alt="" class="imageClass" @load="imageLoad" />
  </div>
</template>

<script>
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { scanUrl } from "@/CommonDP/utils";
export default {
  data() {
    return {
      loadingActive: true,
      urlSrc: ""
    };
  },

  async mounted() {
    const { f, n } = this.$route.query;
    document.title = n;
    const imageSrc = scanUrl(f, "");
    this.$refs.viewerDom.src = imageSrc;
    this.initEvent();
  },

  methods: {
    initEvent() {
      console.log("初始化监听事件");
      document.addEventListener("touchstart", this.touch2mouse, true);
      document.addEventListener("touchmove", this.touch2mouse, true);
      document.addEventListener("touchend", this.touch2mouse, true);
    },

    touch2mouse(event) {
      var touches = event.changedTouches;
      var first = touches[0];
      var type = "";
      switch (event.type) {
        case "touchstart":
          type = "mousedown";
          break;
        case "touchmove":
          type = "mousemove";
          break;
        case "touchend":
          type = "mouseup";
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        first.screenX,
        first.screenY,
        first.clientX,
        first.clientY,
        false,
        false,
        false,
        false,
        null
      );
      first.target.dispatchEvent(simulatedEvent);
    },

    imageLoad() {
      this.loadingActive = false;
      const imageDom = this.$refs.viewerDom;
      this.viewer = new Viewer(imageDom, {
        initialViewIndex: 0,
        button: false,
        navbar: false,
        title: 0,
        toolbar: 0,
        keyboard: true,
        zIndex: 0
      });
      imageDom.click();
    }
  },

  beforeRouteLeave(to, form, next) {
    this.viewer.destroy();
    next();
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#imageContainer {
  width: 100%;
  height: 100%;

  .imageClass {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 50%;
    height: 50%;
    display: none;
  }
}
</style>
